import React, {useState, useEffect} from 'react';
import { Table } from 'react-bootstrap';
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import {Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons"; 
import ImageUploading from 'react-images-uploading';
import { useParams } from "react-router"; 
import { doSocialPostCreate, getSocialPost, doSocialPostUpdate } from '../../Service';
import Swal from "sweetalert2";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";


import Rightbar from './Rightbar';

export default function AddPost(){ 
const navigate = useNavigate();
const [images, setImages] = useState([]);
const [preview, setPreview] = useState('');
const initialValues = {subject: '', instagram_url: '', facebook_url: "", twitter_url: "", caption: '', hashtags: '', file: ''};
const [formValues, setFormValues] = useState(initialValues);
const [formErrors, setFormErrors] = useState({});
const [thumbnail, setThumbnail] = useState('');
const [uploadsize, setUploadsize] = useState('');
const [uploadext, setUploadext] = useState('');
const [fileupdate, setFileupdate] = useState(false);
const [filewithoutext, setFilewithoutext] = useState('');
const maxNumber = 69;
const social_media_id = useParams();
const post_id= (new URLSearchParams(window.location.search)).get("postid");
const onChange = (imageList, addUpdateIndex) => {
// data for submit
console.log(imageList, addUpdateIndex);
setImages(imageList);
};
const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const toggle = () => {
setsidebar(!sidebar);
setmainbar(!mainbar);
}

useEffect(() => {
    let params = {'id':post_id};
    getSocialPost(params).then(res => firstHandleResponse(res.data))
}, []);

const firstHandleResponse = (response) => {
    if(response.code==200){
        setFormValues({subject : response.data.data[0].subject, caption : response.data.data[0].caption, hashtags : response.data.data[0].hashtags , instagram_url : response.data.data[0].instagram_url, facebook_url : response.data.data[0].facebook_url, twitter_url : response.data.data[0].twitter_url});
        if(response.data.data[0].thumbnail_path == null){
            setPreview(response.data.data[0].physical_path);
        }else{
            setPreview(response.data.data[0].thumbnail_path);
        }
        
    } else {
      console.log('no data');
    } 
}

const previewCloseHandler = () => {
    setPreview('')
}

const backpagehandler = () =>{
    navigate(-1);
}

const handlechange = async (e) => {
    if(e.target.type == 'file'){
        const value=e.target.files[0];
        const field=e.target.name;
        setFormValues(prevState => ({
            ...prevState,
            [field]:  value  }));
        console.log('files' ,e.target.files[0])
        const filename = e.target.files[0].name;
        const parts = filename.split(".");
        const withoutext = parts[0];
        setFilewithoutext(withoutext);
        const file_ext=/[^.]+$/.exec(filename); 
        setUploadext(file_ext[0]);
        setUploadsize(e.target.files[0].size);
        setFileupdate(true);
        if(file_ext[0] == 'mp4'){
            setThumbnail(await generateVideoThumbnail(e.target.files[0]));
        }else if(file_ext[0] == 'jpg' || file_ext[0] == 'jpeg'){
            const values = URL.createObjectURL(e.target.files[0]);
            setPreview(values);
        }
    }else {
        const value=e.target.value;
        const field=e.target.name;
        setFormValues(prevState => ({
            ...prevState,
            [field]:  value  }));
    }
}

const generateVideoThumbnail = (file) => {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      const video = document.createElement("video");
  
      // this is important
      video.autoplay = true;
      video.muted = true;
      video.src = URL.createObjectURL(file);
  
      video.onloadeddata = () => {
        let ctx = canvas.getContext("2d");
  
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
  
        ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        video.pause();
        return resolve(canvas.toDataURL("image/png"));
      };
    });
  };

const handleSubmit = (e) => {
    e.preventDefault();
    const errorCount = validate(formValues);
    setFormErrors(errorCount);
    if(errorCount.status){
        if(post_id != null){
            setFormValues(formValues['id'] = post_id);
            setFormValues(formValues['social_media_id'] = social_media_id.id);
            if(thumbnail){
                setFormValues(formValues['thumbnail'] = thumbnail);
            }
            doSocialPostUpdate(formValues).then(res => handleResponse(res));
        } else {
            setFormValues(formValues['id'] = social_media_id.id);
            if(thumbnail){
                setFormValues(formValues['thumbnail'] = thumbnail);
            }
            doSocialPostCreate(formValues).then(res => handleResponse(res));
        }
        
    }
}

const handleResponse = (response) => {
    if(response.data.code==200){
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Post Created Successfully!',
            showConfirmButton: false,
            timer: 2500
        })
        navigate(-1);
    } else {
      setFormValues(formValues);
      const errors = {};
      Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: response.data.message,
      })
      errors.invalid = response.data.data.message;
      errors.status = false;
      setFormErrors(errors);
    }  
}

const validate = (values) => {
    const errors = {};
    errors.status = true;
    const insta_url_regex = /^@[a-zA-Z0-9_]{4,20}$/;
    const facebook_url_regex = /^(https?:\/\/)?((w{3}\.)?)facebook.com\/.*/i;
    const twitter_url_regex = /^@[a-zA-Z0-9_]{4,20}$/;
    const file_name_specialchar_regex = /^[^*|\":<>[\]{}`\\()';@& $]+$/;

    if(!values.subject){
        errors.subject = 'Subject is required';
        errors.status = false;
    }

    if(!values.instagram_url){
        errors.instagram_url = 'Instagram handle is required';
        errors.status = false;
    } else if(values.instagram_url && !insta_url_regex.test(values.instagram_url)) {
        errors.instagram_url = "This is not a valid Instagram handle, must include @ Symble.";
        errors.status = false;
    }

    if(!values.facebook_url){
        errors.facebook_url = 'Facebook page URL is required';
        errors.status = false;
    } else if(values.facebook_url && !facebook_url_regex.test(values.facebook_url)) {
        errors.facebook_url = "This is not a valid Facebook page URL.";
        errors.status = false;
    }

    if(!values.twitter_url){
        errors.twitter_url = 'Twitter handle is required';
        errors.status = false;
    } else if(values.twitter_url && !twitter_url_regex.test(values.twitter_url)) {
        errors.twitter_url = "This is not a valid Twitter handle, must have @ symble and min 4 char.";
        errors.status = false;
    }
    if(fileupdate === true){
        if(!values.file){
            errors.file = 'File is required';
            errors.status = false;
        }else if(uploadext === 'jpg' || uploadext === 'jpeg'){
            if(uploadsize >  2097152) {
                errors.file = 'Image size less than or equal to 2 MB.';
                errors.status = false;
            }
        }
        else if(!file_name_specialchar_regex.test(filewithoutext)){
            errors.file = 'without special char';
            errors.status = false;
        }
    }
    if(post_id === null){
        if(!values.file){
            errors.file = 'File is required';
            errors.status = false;
        }else if(!file_name_specialchar_regex.test(filewithoutext)){
            errors.file = 'This is not valid Filename.';
            errors.status = false;
        }
    }
    

    return errors;
  }
  console.log(filewithoutext)
return(
<>
<section className="sec-container" >
<div className='container'>
<div className='portalevent'>
<div className='row'>
<div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
<div >
<Rightbar/>
</div>
</div>
<div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
<div className='rightbar '>
<Button variant="outline-info" onClick={toggle}>
<FontAwesomeIcon icon={faAlignLeft} />
</Button>
<div className='add-post'>
<h1>Add Post</h1>
<div className='gry-bg'>
<h3 >File Specifications:</h3>
<p>
Images: jpg, sRGB, 72dpi, 2MB<br />
Videos (IG/FB stories): {'<= '} 10 seconds<br />
Videos (IGTV stories): {'<= '} 1 minute<br />
File names cannot contain any apostrophes or special characters ({'" "@ \ / | : <> *'})
</p>
</div>

<Form onSubmit={handleSubmit}>
<div className='row'>      

<div className='col-md-8 col-12'>

<Form.Group controlId="exampleForm.ControlInput1">
<Form.Label>Subject (artist name, gallery tour, etc.)<span className='star'>*</span></Form.Label>
<Form.Control type="text" placeholder="Subject" defaultValue={formValues.subject} name="subject" onChange={handlechange}/>
<p className="error">{formErrors.subject}</p>
</Form.Group>
<Form.Group controlId="exampleForm.ControlInput1">
<Form.Label>Artist Instagram Handle</Form.Label>
<Form.Control type="text" placeholder="Instagram Handle" defaultValue={formValues.instagram_url} name="instagram_url" onChange={handlechange} />
<p className="error">{formErrors.instagram_url}</p>
</Form.Group>
<Form.Group ontrolId="exampleForm.ControlInput1">
<Form.Label>Artist Facebook Page </Form.Label>
<Form.Control type="text" placeholder="Facebook Page URL" defaultValue={formValues.facebook_url} name="facebook_url" onChange={handlechange} />
<p className="error">{formErrors.facebook_url}</p>
</Form.Group>
<Form.Group controlId="exampleForm.ControlInput1">
<Form.Label>Artist Twitter Handle</Form.Label>
<Form.Control type="text" placeholder="Twitter Handle" defaultValue={formValues.twitter_url} name="twitter_url" onChange={handlechange} />
<p className="error">{formErrors.twitter_url}</p>
</Form.Group>
<Form.Group controlId="exampleForm.ControlInput1">
<Form.Label>Caption (optional)</Form.Label>
<Form.Control type="text" placeholder="Caption" defaultValue={formValues.caption} name="caption" onChange={handlechange} />
</Form.Group>
<Form.Group controlId="exampleForm.ControlInput1">
<Form.Label>Hashtags (optional)</Form.Label>
<Form.Control type="text" placeholder="Hashtags" defaultValue={formValues.hashtags} name="hashtags" onChange={handlechange} />
<p className="error">{formErrors.invalid}{formErrors.message}</p>
</Form.Group>
</div>
<div className='col-md-4 col-12 middle-aln'>
<Form.Group controlId="exampleForm.ControlInput1">
    <Form.Label for="file" className="social-media-file-lable">
    
    <img src={thumbnail ? thumbnail :  preview ? preview : process.env.PUBLIC_URL+'/images/default-img.png'} className="img-responsive" />
    {
        preview ? (
            <FontAwesomeIcon onClick={previewCloseHandler} className='close-preview-img' icon={faCircleXmark} />
        ) : ''
    }
    <Form.Control className="social-media-file" id="file" name="file" type="file" onChange={handlechange} accept=".jpg, .jpeg, .mp4, .mov"/>
    <p className="error">{formErrors.file}</p>
    </Form.Label>
</Form.Group>
</div>
</div><br/> 
<div className='text-center'>
<Button className='common-btn' type='submit'>SAVE</Button>{' '}
<Button className='cancel-btn' onClick={backpagehandler}>CANCEL</Button>{' '}
</div>
</Form>
 <br/>
</div>
</div>
</div>
</div>
</div>
</div>
</section>  


</>
)
}